































































































































































































import {
  defineComponent,
  PropType,
  SetupContext,
} from '@nuxtjs/composition-api';
import useAppRoute from '~/compositions/useAppRoute';
import { CorporationEventInternship } from '~/graphql/graphqlOperations';
export default defineComponent({
  props: {
    internship: {
      type: Object as PropType<CorporationEventInternship>,
      required: true,
    },
  },
  setup(_, _context: SetupContext) {
    const { URLs } = useAppRoute();
    return {
      URLs,
    };
  },
});
